export const defaultRegistryUrl =
  'https://www.python.org/api/v2/downloads/release';
export const githubBaseUrl = 'https://api.github.com/';

export const datasource = 'python-version';
